import { createSelector } from 'reselect';

import { selectPermissions } from '../user/selectors';

export const sidenavSelector = createSelector(
  [selectPermissions],
  ({
    showCrmUserSideNav,
    showBenchmarkReportsMenuItemFeatureFlag,
    showBenchmarkReportsMenuItemIfFeatureFlag,
    showDemandUserSideNavIfFeatureFlag,
    showDemandUserSideNavFeatureFlag,
    showSelfServiceUserSideNavIfFeatureFlag,
    showSelfServiceUserSideNavFeatureFlag,
    showMCIReportsMenuItemIfFeatureFlag,
    showMCIReportsMenuItemFeatureFlag,
    showPerformanceSummaryMenuItem,
    showInternalUserSideNav,
    showHomeMenuItem,
    showHomeMenuItemIfFeatureFlag,
    showHomeMenuItemFeatureFlag,
    showExternalUserSideNavIfFeatureFlag,
    showExternalUserSideNavFeatureFlag,
    showSelfServiceUserSideNavbar,
  }) => ({
    showBenchmarkReportsMenuItem:
      showBenchmarkReportsMenuItemFeatureFlag &&
      showBenchmarkReportsMenuItemIfFeatureFlag,
    showCrmUserSideNav,
    showDemandUserSideNav:
      showDemandUserSideNavIfFeatureFlag && showDemandUserSideNavFeatureFlag,
    showExternalUserSideNav:
      showExternalUserSideNavIfFeatureFlag &&
      !showExternalUserSideNavFeatureFlag,
    showHomeMenuItem:
      showHomeMenuItem ||
      (showHomeMenuItemIfFeatureFlag && showHomeMenuItemFeatureFlag),
    showInternalUserSideNav,
    showMCIReportsMenuItem:
      showMCIReportsMenuItemIfFeatureFlag && showMCIReportsMenuItemFeatureFlag,
    showPerformanceSummaryMenuItem,
    showSelfServiceUserSideNav:
      (!showCrmUserSideNav &&
        showSelfServiceUserSideNavIfFeatureFlag &&
        showSelfServiceUserSideNavFeatureFlag) ||
      showSelfServiceUserSideNavbar,
  })
);
